var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllLeadsInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.417A.583.583 0 0 0 5.417 6v2.333a.583.583 0 0 0 1.166 0V6A.583.583 0 0 0 6 5.417zm.222-2.287a.583.583 0 0 0-.444 0 .583.583 0 0 0-.192.122.67.67 0 0 0-.123.193.583.583 0 0 0 .122.636.67.67 0 0 0 .193.122.583.583 0 0 0 .636-.95.583.583 0 0 0-.192-.123zM6 .167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 6 .167zm0 10.5a4.667 4.667 0 1 1 0-9.334 4.667 4.667 0 0 1 0 9.333z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllLeadsInfoIcon);
export default __webpack_public_path__ + "static/media/all-leads-info-icon.6bead4fe50527045c0d5a8075210cd52.svg";
export { ForwardRef as ReactComponent };